'use client';

import { c as _c } from "react/compiler-runtime";
import { tickerLabel } from '@/components/search/search-row-parts.utils';
import { cn } from '@/lib/ui/utils';
interface TickerTextProps {
  ticker: string | undefined;
  /** Tint the ticker (warning/amber) — used in `$ticker` search mode. */
  highlighted?: boolean | undefined;
}
export function TickerText(t0) {
  const $ = _c(7);
  const {
    ticker,
    highlighted: t1
  } = t0;
  const highlighted = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== ticker) {
    t2 = tickerLabel(ticker);
    $[0] = ticker;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const label = t2;
  if (label === null) {
    return null;
  }
  const t3 = highlighted ? "text-feedback-warning-content" : "text-foreground-tertiary";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("font-mono text-caption", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== label || $[5] !== t4) {
    t5 = <span className={t4}>{label}</span>;
    $[4] = label;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
type AsideTone = 'default' | 'success' | 'destructive';
interface RowAsideProps {
  /** Primary right-hand metric. */
  value: string;
  /** Small label beneath the metric. */
  label: string;
  tone?: AsideTone;
  /** Render the value in mono (used for the live outcome %). */
  mono?: boolean;
}
const TONE_CLASS: Record<AsideTone, string> = {
  default: 'text-foreground-primary',
  success: 'text-feedback-success-content',
  destructive: 'text-feedback-error-content'
};
export function RowAside(t0) {
  const $ = _c(11);
  const {
    value,
    label,
    tone: t1,
    mono: t2
  } = t0;
  const tone = t1 === undefined ? "default" : t1;
  const mono = t2 === undefined ? false : t2;
  const t3 = mono && "font-mono";
  const t4 = TONE_CLASS[tone];
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = cn("text-body font-semibold tabular-nums", t3, t4);
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t5 || $[4] !== value) {
    t6 = <span className={t5}>{value}</span>;
    $[3] = t5;
    $[4] = value;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== label) {
    t7 = <span className="text-micro text-foreground-tertiary">{label}</span>;
    $[6] = label;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <div className="flex shrink-0 flex-col items-end gap-0.5 text-right">{t6}{t7}</div>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}